import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminAccountComponent } from './admin-account.component';

const routes: Routes = [
  {
    path: '',
    component: AdminAccountComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminAccountRoutingModule {}
